export default __webpack_public_path__ + "static/media/rainy-6.130d6250.svg";